export enum DATA_QA {
  ROOT = 'dnc-import-map-step',
  BACK = 'dnc-import-map-step__back',
  NEXT = 'dnc-import-map-step__next',
  FAMILIAR_NOTICE_CLOSE = 'dnc-import-map-step__familiar-notice-close',
}
